import { render, staticRenderFns } from "./StatList.vue?vue&type=template&id=735225a2&scoped=true"
import script from "./StatList.vue?vue&type=script&lang=js"
export * from "./StatList.vue?vue&type=script&lang=js"
import style0 from "./StatList.vue?vue&type=style&index=0&id=735225a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735225a2",
  null
  
)

export default component.exports